import { useNavigate } from 'react-router-dom';

export default function WhySpreadsheet() {
  const navigate = useNavigate();

  const advantages = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Экономия до 40%',
      desc: 'Сравнение всех расходов заранее позволяет существенно снизить итоговую стоимость заказа.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Прозрачность',
      desc: 'Никаких скрытых комиссий — все цены и сборы отображаются в таблице YOYBUY spreadsheet.',
    },
    {
      icon: 'ri-thumb-up-line',
      title: 'Удобство',
      desc: 'Все товары в одной таблице — не нужно переключаться между страницами и сервисами.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Контроль',
      desc: 'Полный контроль над процессом закупок от выбора товара до отслеживания доставки.',
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            Почему пользователи выбирают YOYBUY Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            Тысячи покупателей уже оценили преимущества работы через таблицы Kaspreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {advantages.map((item, idx) => (
            <div
              key={idx}
              className="p-6 rounded-xl bg-background-100 border border-secondary-200/50 hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-50 mb-4">
                <i className={`${item.icon} w-5 h-5 flex items-center justify-center text-primary-500`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="mt-14 relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20photography%20of%20fashion%20items%20neatly%20arranged%20on%20a%20light%20wooden%20table%2C%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20Scandinavian%20style%2C%20products%20include%20sneakers%20bags%20and%20accessories%20in%20neutral%20earth%20tones%2C%20clean%20composition%20with%20plenty%20of%20copy%20space%20on%20the%20left%20side%2C%20editorial%20aesthetic%2C%20bright%20and%20airy%20atmosphere&width=1400&height=500&seq=cta-banner-yoybuy-01&orientation=landscape"
            alt="YOYBUY Spreadsheet платформа"
            title="Начните использовать YOYBUY Spreadsheet"
            className="w-full h-64 md:h-80 object-cover object-center"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/55 to-black/25 flex items-center">
            <div className="px-8 md:px-14">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
                Начните использовать YOYBUY Spreadsheet сегодня
              </h3>
              <p className="text-white/80 text-sm md:text-base mb-6 max-w-md">
                Получите доступ к таблице товаров и начните экономить на покупках из Китая прямо сейчас
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-6 py-3 rounded-full bg-white text-primary-700 text-sm font-semibold hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                >
                  Перейти к платформе
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <button
                  onClick={() => navigate('/blog/yoybuy-spreadsheet-guide')}
                  className="px-6 py-3 rounded-full border-2 border-white/70 text-white text-sm font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
                >
                  Подробный гид
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}